'use strict';

exports.__esModule = true;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _localstorage = require('./localstorage.mock');

var _localstorage2 = _interopRequireDefault(_localstorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var namespace = 'QU'; /**
                       * Global name for store
                       * @ignore
                       */

var localstorage = null;

initWithNamespace(namespace);

var storeService = {
  add: add,
  remove: remove,
  get: get,
  store: store,
  clear: clear
};

exports.default = storeService;


function add(key, value) {
  var items = storeService.store();

  items[key] = value;
  localstorage.setItem(namespace, (0, _stringify2.default)(items));

  return storeService;
}

function remove(key) {
  var items = storeService.store();
  if (items) delete items[key];
  localstorage.setItem(namespace, (0, _stringify2.default)(items));

  return storeService;
}

function get(key) {
  var items = storeService.store();

  return items[key];
}

function store() {
  return JSON.parse(localstorage.getItem(namespace));
}

function clear() {
  localstorage.removeItem(namespace);
  initWithNamespace(namespace);

  return storeService;
}

function initWithNamespace(nspace) {
  if (islocalStorageAvailable()) {
    localstorage = checkPrivateMode();
  } else {
    localstorage = _localstorage2.default;
  }

  var currentData = localstorage.getItem(nspace);
  localstorage.setItem(nspace, currentData || '{}');
}

function polyfillStorage() {
  var _this = this;

  try {
    window.Storage.prototype.data = {};
    window.Storage.prototype.removeItem = function (id) {
      delete _this.data[id];
    };
    window.Storage.prototype.clear = function () {
      _this.data = {};
    };
    window.Storage.prototype.setItem = function (id, val) {
      _this.data[id] = String(val);
    };
    window.Storage.prototype.getItem = function (id) {
      return _this.data.hasOwnProperty(id) ? _this.data[id] : null;
    };

    return window.localStorage;
  } catch (e) {
    return _localstorage2.default;
  }
}

function checkPrivateMode() {
  try {
    var item = 'test-storage';
    window.localStorage.setItem(item, item);
    window.localStorage.removeItem(item);
    return window.localStorage;
  } catch (e) {
    return polyfillStorage();
  }
}

function islocalStorageAvailable() {
  return typeof window !== 'undefined' && window.localStorage;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/services/store.js
// module id = 412
// module chunks = 0